// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3mEzs","insightsList":"newBusinessInsightsMenu_insightsList__L0V_o","active":"newBusinessInsightsMenu_active__uWxjX"};